import {
  GOOGLE_TRANSLATE_CHANGE_LANGUAGE,
  GOOGLE_TRANSLATE_READY,
  GOOGLE_TRANSLATE_RESET,
  INIT_GOOGLE_TRANSLATE,
  googleTranslateElementWrapperId,
  ploneTranslateMapping,
  translateCookieName,
} from 'volto-google-translate/constants';

function _getTranslateSelect() {
  const translateWrapper = document.getElementById(
    googleTranslateElementWrapperId,
  );
  if (translateWrapper) {
    return translateWrapper.querySelector('select');
  }
}

function _getCookieValue() {
  return document.cookie
    .split('; ')
    .find((cookieString) => cookieString.startsWith(translateCookieName));
}

function changeLanguage(state, { language }) {
  const select = _getTranslateSelect();
  let googleLanguage = language;
  if (select) {
    if (language) {
      let [languageCode, countryCode] = language.split('-');
      countryCode = !countryCode ? language.split('_')[-1] : countryCode; // Support both formats of language mappings in Plone
      // TODO: Compute this at load time/ memoise to make switching faster
      if (countryCode) {
        // Google always uses a dash
        const upperLanguage = `${languageCode}-${countryCode.toUpperCase()}`;
        const lowerLanguage = `${languageCode}-${countryCode.toLowerCase()}`;
        const sentenceLangauge = `${languageCode}-${countryCode.replace(
          countryCode.charAt(0),
          countryCode.charAt(0).toUpperCase(),
        )}`;
        for (const option of select.options) {
          if (option.value === upperLanguage) {
            googleLanguage = upperLanguage;
          } else if (option.value === lowerLanguage) {
            googleLanguage = lowerLanguage;
          } else if (option.value === sentenceLangauge) {
            googleLanguage = sentenceLangauge;
          }
        }
      }
    }

    if (ploneTranslateMapping[language.toLowerCase()]) {
      googleLanguage = ploneTranslateMapping[language];
    } else if (ploneTranslateMapping[googleLanguage.toLowerCase()]) {
      googleLanguage = ploneTranslateMapping[googleLanguage];
    }

    select.value = googleLanguage;
    select.dispatchEvent(new Event('change'));
  }
  state.language = language;
}

function resetTranslation(state) {
  const select = _getTranslateSelect();
  if (select) {
    select.value = '';
  }

  // Remove cookie set by google translate that causes page revisits to be translated
  if (_getCookieValue()) {
    document.cookie = `${translateCookieName}=''; expires=${new Date(
      -1,
    ).toUTCString()}; max-age=0`;
    // Translate code can potentialy be set on multiple domain variations. Let's make sure they're all deleted
    document.cookie = `${translateCookieName}=''; expires=${new Date(
      -1,
    ).toUTCString()}; domain=${
      new URL(window.location.href).hostname
    }; max-age=0`;
    document.cookie = `${translateCookieName}=''; expires=${new Date(
      -1,
    ).toUTCString()}; domain=.${
      new URL(window.location.href).hostname
    }; max-age=0`;
  }

  state.language = '';

  const restoreGoogleTranslate = Object.values(
    window.translateInstance || {},
  ).find((key) => key?.restore)?.restore;
  if (restoreGoogleTranslate) {
    restoreGoogleTranslate();
  }
}

function translateInit(state) {
  // This dependency comes from the script in injectTranslateScript
  window.translateInstance = new google.translate.TranslateElement(
    {},
    googleTranslateElementWrapperId,
  );

  state.loading = false;
  state.loaded = true;

  const cookie = _getCookieValue();
  if (cookie) {
    state.language = cookie;
  }
}

function sendGoogleTranslateReadyCustomEvent() {
  // TODO: Add check for element existing here to verify it was created and update error state
  const event = new CustomEvent(GOOGLE_TRANSLATE_READY);
  document.dispatchEvent(event);
}

function injectTranslateScript(state) {
  window.translateInit = sendGoogleTranslateReadyCustomEvent;
  const widgetSource =
    'https://translate.google.com/translate_a/element.js?cb=window.translateInit';
  if (!document.querySelector(`script[src="${widgetSource}"]`)) {
    const t = document.createElement('script');
    t.src = widgetSource;
    document.head.appendChild(t);
  }

  state.loading = true;
}

const actionHandlerMapping = {
  [INIT_GOOGLE_TRANSLATE]: injectTranslateScript,
  [GOOGLE_TRANSLATE_READY]: translateInit,
  [GOOGLE_TRANSLATE_CHANGE_LANGUAGE]: changeLanguage,
  [GOOGLE_TRANSLATE_RESET]: resetTranslation,
};

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  language: '',
};

export const googleTranslateReducer = (state = initialState, action = {}) => {
  const handler = actionHandlerMapping[action.type];
  if (handler) {
    handler(state, action);
  }
  return state;
};
